import { createMutationHook } from "@accurx/api/QueryClient";
import {
    ViewPatientTokenUnprotectRequest,
    ViewPatientTokenUnprotectResponse,
} from "@accurx/api/portal";
import { httpClient2 } from "@accurx/shared";

export const RedeemPatientTokenKey = "RedeemPatientToken";

export const useRedeemPatientToken = createMutationHook<
    ViewPatientTokenUnprotectRequest,
    ViewPatientTokenUnprotectResponse
>(() => ({
    mutationKey: [RedeemPatientTokenKey],
    mutationFn: async ({ token }) =>
        httpClient2
            .post({
                path: "/api/portal/viewPatient/redeemToken",
                json: { token },
            })
            .json<ViewPatientTokenUnprotectResponse>(),
}));
